import React from "react";
import { useLang } from "@/lib/i18n";
import SeoLandingPage from "@/components/SeoLandingPage";
import { wagenparkreinigingNL } from "@/data/seo-landing-pages";

const Wagenparkreiniging = () => {
  const { lang } = useLang();
  return <SeoLandingPage data={wagenparkreinigingNL} lang={lang} />;
};

export default Wagenparkreiniging;
